import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(3),
  },
  itemQuesito: {
    marginTop: theme.spacing(2),
    width: '100%',
  },
  perguntaQuesito: {
    width: '100%',
    fontWeight: 'bold',
    fontSize: '14px',
    backgroundColor: theme.palette.background?.default || '#f4f6f8',
    color: theme.palette.text?.primary || '#263238',
    padding: theme.spacing(1.5),
    borderLeft: `4px solid ${theme.palette.primary?.main || '#2196f3'}`,
    borderRadius: '4px 0 0 4px',
    marginBottom: theme.spacing(1),
  },
  inputResposta: {
    marginTop: theme.spacing(0.5),
  },
}))
